(() => {
  const $ = id => document.getElementById(id);

  // ── FONT URLS ─────────────────────────────────────────────────────────────
  // Upload the 3 .otf files to Shopify Admin → Content → Files,
  // then replace these 3 URLs with the cdn.shopify.com URLs Shopify gives you.
  const FONT_URLS = {
    serifReg:  'https://cdn.shopify.com/s/files/1/0452/4156/5345/files/Cinzel-Regular.otf?v=1772675328',
    serifBold: 'https://cdn.shopify.com/s/files/1/0452/4156/5345/files/Cinzel-Bold.otf?v=1772675328',
    script:    'https://cdn.shopify.com/s/files/1/0452/4156/5345/files/Castely.otf?v=1772675328',
  };
  // ─────────────────────────────────────────────────────────────────────────

  const ot = window.opentype;
  const otFonts = {};
  let fontState = 'idle';

  function setStatus(msg, cls) {
    const el = $('vb-fontStatus'); if (!el) return;
    el.textContent = msg; el.className = cls || '';
  }

  async function loadFonts() {
    if (fontState === 'ready') return true;
    if (fontState === 'loading') return false;
    fontState = 'loading';
    setStatus('Loading fonts…');
    try {
      const [r1, r2, r3] = await Promise.all(Object.values(FONT_URLS).map(url =>
        fetch(url).then(r => { if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + url); return r.arrayBuffer(); })
      ));
      otFonts.serifReg  = ot.parse(r1);
      otFonts.serifBold = ot.parse(r2);
      otFonts.script    = ot.parse(r3);
      fontState = 'ready';
      setStatus('✓ Fonts loaded — text exported as outlines', 'ready');
      render();
    } catch(e) {
      console.error('Font load error:', e);
      fontState = 'error';
      setStatus('⚠ Font load failed — check CDN URLs in console', 'error');
    }
    return fontState === 'ready';
  }

  // ── Geometry ──────────────────────────────────────────────────────────────

  function spiralPathD(cx,cy,r0,r1,turns,pts=2400){
    const tMax=turns*Math.PI*2,k=(r1-r0)/tMax;let d='';
    for(let i=0;i<=pts;i++){const t=(i/pts)*tMax,r=r0+k*t,x=cx+r*Math.cos(t-Math.PI/2),y=cy+r*Math.sin(t-Math.PI/2);d+=(i===0?`M ${x.toFixed(3)} ${y.toFixed(3)} `:`L ${x.toFixed(3)} ${y.toFixed(3)} `);}
    return d;
  }

  function makeSpiralText(lyrics,approxLen,fs){
    const clean=(lyrics||'').replace(/\s+/g,' ').trim();if(!clean)return'';
    const sep=' \u2022 ',base=clean.endsWith('.')?clean:clean+'.';
    const reps=Math.max(1,Math.ceil(Math.ceil(approxLen/(fs*0.55))/(base.length+sep.length)));
    let out='';for(let i=0;i<reps;i++)out+=base+sep;return out.trim();
  }

  function applyTheme(t){$('vb-board').style.background=(t==='wood')?'#ffffff':'#0a0a0a';}

  function chordBandPath(cx,cy,r,yTop,yBot){
    yTop=Math.max(cy-r+0.01,yTop);yBot=Math.min(cy+r-0.01,yBot);if(yBot<=yTop)return'';
    const hwT=Math.sqrt(Math.max(0,r*r-(yTop-cy)**2)),hwB=Math.sqrt(Math.max(0,r*r-(yBot-cy)**2));
    return`M ${(cx-hwT).toFixed(3)},${yTop.toFixed(3)} L ${(cx+hwT).toFixed(3)},${yTop.toFixed(3)} L ${(cx+hwB).toFixed(3)},${yBot.toFixed(3)} L ${(cx-hwB).toFixed(3)},${yBot.toFixed(3)} Z`;
  }

  function ringPath(cx,cy,oR,iR){
    const a=r=>`M ${(cx+r).toFixed(3)},${cy.toFixed(3)} A ${r.toFixed(3)},${r.toFixed(3)} 0 1 0 ${(cx-r).toFixed(3)},${cy.toFixed(3)} A ${r.toFixed(3)},${r.toFixed(3)} 0 1 0 ${(cx+r).toFixed(3)},${cy.toFixed(3)} Z`;
    return a(oR)+' '+a(iR);
  }

  function wrapTitle(text,maxW,fs){
    const cw=fs*0.54,words=text.split(' ');let lines=[],cur='';
    for(const w of words){const t=cur?cur+' '+w:w;if(cur&&t.length*cw>maxW){lines.push(cur);cur=w;}else cur=t;}
    if(cur)lines.push(cur);return lines.length?lines:[text];
  }

  function textAsPath(text,x,y,font,fs,anchor,fill){
    if(!text||!font)return'';
    const w=font.getAdvanceWidth(text,fs);
    const sx=anchor==='middle'?x-w/2:anchor==='end'?x-w:x;
    const d=font.getPath(text,sx,y,fs).toPathData(3);
    return d?`<path fill="${fill}" d="${d}"/>`:'';
  }

  function spiralTextAsPaths(spiralEl,text,font,fs,fill){
    if(!spiralEl||!text||!font)return'';
    const total=spiralEl.getTotalLength();let offset=0,out='';
    for(let i=0;i<text.length;i++){
      if(offset>=total)break;
      const ch=text[i],adv=font.getAdvanceWidth(ch,fs);
      if(!ch.trim()){offset+=adv;continue;}
      if(font.charToGlyph(ch).name==='.notdef'){offset+=adv;continue;}
      const pt=spiralEl.getPointAtLength(offset),pt2=spiralEl.getPointAtLength(Math.min(offset+0.5,total));
      const deg=Math.atan2(pt2.y-pt.y,pt2.x-pt.x)*180/Math.PI;
      const d=font.getPath(ch,0,0,fs).toPathData(3);
      if(d)out+=`<path fill="${fill}" transform="translate(${pt.x.toFixed(3)},${pt.y.toFixed(3)}) rotate(${deg.toFixed(3)})" d="${d}"/>`;
      offset+=adv;
    }
    return out;
  }

  let prevUnit='mm';

  function calcLayout(){
    const toMM=v=>(prevUnit==='in')?v*25.4:v;
    const W=toMM(+$('vb-boardW').value),H=toMM(+$('vb-boardH').value),cornerR=toMM(+$('vb-cornerR').value);
    const theme=$('vb-theme').value,recordPct=+$('vb-recordPct').value,topMargin=toMM(+$('vb-topMargin').value);
    const turns=+$('vb-turns').value,spiralFont=+$('vb-spiralFont').value,spiralGap=toMM(+$('vb-spiralGap').value),labelPct=+$('vb-labelPct').value;
    const recordR=(recordPct/100)*W/2,cx=W/2,cy=topMargin+recordR,labelR=(labelPct/100)*recordR,holeR=labelR*0.12;
    const _pad=Math.max(1,22-spiralGap),spiralInner=labelR+_pad*0.8,spiralOuter=recordR-_pad*0.6;
    const spiralD=spiralPathD(cx,cy,spiralInner,spiralOuter,turns,2600);
    const spiralText=makeSpiralText($('vb-lyrics').value,Math.PI*turns*(spiralInner+spiralOuter),spiralFont);
    const titleSize=+$('vb-titleFont').value,artistSize=+$('vb-artistFont').value,scriptSize=+$('vb-customFont').value,namesSize=+$('vb-namesFont').value,dateSize=+$('vb-dateFont').value;
    const spiralBottom=cy+spiralOuter,midGap=spiralBottom+(H-spiralBottom)/2,blockH=namesSize+dateSize+6;
    const namesY=midGap-blockH/2+namesSize,dateY=namesY+dateSize+6;
    const labelRingD=ringPath(cx,cy,labelR+1.3,labelR-1.3);
    const _g=holeR+labelR*0.06,_bh=labelR*0.035;
    const band1D=chordBandPath(cx,cy,labelR,cy-_g-_bh,cy-_g),band2D=chordBandPath(cx,cy,labelR,cy+_g,cy+_g+_bh);
    const titleLines=wrapTitle($('vb-song').value,labelR*1.55,titleSize);
    const _lh=+$('vb-labelLineH').value,titleLineH=titleSize*(titleLines.length>1?Math.min(_lh,1.1):_lh);
    const tzTop=cy-labelR+labelR*0.06,tzBot=cy-holeR-labelR*0.06-labelR*0.035;
    const tContentH=titleLines.length*titleLineH-(titleLineH-titleSize)+artistSize*1.5;
    const titleStartY=tzTop+(tzBot-tzTop-tContentH)/2+titleSize,artistY=titleStartY+titleLines.length*titleLineH+artistSize*0.2;
    return{W,H,cornerR,theme,spiralFont,spiralD,spiralText,cx,cy,labelR,holeR,labelRingD,band1D,band2D,
           titleLines,titleLineH,titleStartY,artistY,namesY,dateY,titleSize,artistSize,scriptSize,namesSize,dateSize,
           song:$('vb-song').value,artist:$('vb-artist').value,customLine:$('vb-customLine').value,
           names:$('vb-names').value,date:$('vb-date').value};
  }

  function makeTmpPath(l){
    const NS='http://www.w3.org/2000/svg',s=document.createElementNS(NS,'svg');
    s.setAttribute('width',String(l.W));s.setAttribute('height',String(l.H));
    s.style.cssText='position:fixed;top:0;left:0;opacity:0;pointer-events:none;z-index:-999;';
    const p=document.createElementNS(NS,'path');p.setAttribute('d',l.spiralD);
    s.appendChild(p);document.body.appendChild(s);
    return{tmpSvg:s,tmpPath:p};
  }

  function buildBody(l,tmpPath,eng,engSoft,bgFill){
    const sf=($('vb-spiralFontStyle').value==='bold')?otFonts.serifBold:otFonts.serifReg;
    let b=`<rect width="${l.W}" height="${l.H}" rx="${l.cornerR}" ry="${l.cornerR}" fill="${bgFill}"/>`;
    b+=spiralTextAsPaths(tmpPath,l.spiralText,sf,l.spiralFont,eng);
    b+=`<path d="${l.labelRingD}" fill="${eng}" fill-rule="evenodd"/>`;
    b+=`<path d="${l.band1D}" fill="${eng}"/>`;
    b+=`<path d="${l.band2D}" fill="${eng}"/>`;
    b+=`<circle cx="${l.cx.toFixed(3)}" cy="${l.cy.toFixed(3)}" r="${l.holeR.toFixed(3)}" fill="${eng}"/>`;
    for(let i=0;i<l.titleLines.length;i++) b+=textAsPath(l.titleLines[i],l.cx,l.titleStartY+i*l.titleLineH,otFonts.serifBold,l.titleSize,'middle',eng);
    b+=textAsPath(l.artist,l.cx,l.artistY,otFonts.serifReg,l.artistSize,'middle',engSoft);
    b+=textAsPath(l.customLine,l.cx,l.cy+l.holeR+l.labelR*0.44,otFonts.script,l.scriptSize,'middle',eng);
    b+=textAsPath(l.names,l.cx,l.namesY,otFonts.script,l.namesSize,'middle',eng);
    b+=textAsPath(l.date,l.cx,l.dateY,otFonts.serifBold,l.dateSize,'middle',eng);
    return b;
  }

  function render(){
    const l=calcLayout();
    $('vb-board').style.borderRadius=l.cornerR+'px';
    $('vb-boardWrap').style.borderRadius=l.cornerR+'px';
    $('vb-boardWrap').style.aspectRatio=l.W+' / '+l.H;
    applyTheme(l.theme);
    const isWood=l.theme==='wood',bgFill=isWood?'#ffffff':'#0a0a0a',eng=isWood?'#1a1a1a':'#ffffff';
    const{tmpSvg,tmpPath}=makeTmpPath(l);
    const body=buildBody(l,tmpPath,eng,eng,bgFill);
    document.body.removeChild(tmpSvg);
    const units=$('vb-units').value;
    $('vb-svgHost').innerHTML=`<svg xmlns="http://www.w3.org/2000/svg" width="${$('vb-boardW').value}${units}" height="${$('vb-boardH').value}${units}" viewBox="0 0 ${l.W} ${l.H}"><g id="ENGRAVE_LAYER">${body}</g></svg>`;
  }

  async function downloadSVG(){
    if(fontState!=='ready'){
      setStatus('Waiting for fonts…');
      const ok=await loadFonts();
      if(!ok)return;
    }
    const l=calcLayout(),units=$('vb-units').value;
    const isWood=l.theme==='wood',bgFill=isWood?'#ffffff':'#0a0a0a',eng=isWood?'#1a1a1a':'#ffffff',engSoft=isWood?'#444444':'#c8d4e8';
    const{tmpSvg,tmpPath}=makeTmpPath(l);
    const body=buildBody(l,tmpPath,eng,engSoft,bgFill);
    document.body.removeChild(tmpSvg);
    const svgStr=`<?xml version="1.0" encoding="UTF-8"?>\n<!-- All text as outlines -->\n<svg xmlns="http://www.w3.org/2000/svg" width="${$('vb-boardW').value}${units}" height="${$('vb-boardH').value}${units}" viewBox="0 0 ${l.W} ${l.H}"><g id="ENGRAVE_LAYER">${body}</g></svg>`;
    const a=Object.assign(document.createElement('a'),{href:URL.createObjectURL(new Blob([svgStr],{type:'image/svg+xml;charset=utf-8'})),download:'vinyl_spiral_paths.svg'});
    document.body.appendChild(a);a.click();a.remove();
  }

  const DIM_IDS=['vb-boardW','vb-boardH','vb-cornerR','vb-topMargin','vb-spiralGap'];
  function onUnitsChange(){
    const next=$('vb-units').value;if(next===prevUnit)return;
    const f=(next==='in')?1/25.4:25.4,dec=(next==='in')?3:1;
    DIM_IDS.forEach(id=>{const el=$(id);if(!el)return;el.value=(parseFloat(el.value)*f).toFixed(dec);el.step=(next==='in')?'0.01':'1';});
    prevUnit=next;render();
  }

  ['vb-spiralFontStyle','vb-boardW','vb-boardH','vb-cornerR','vb-theme','vb-lyrics','vb-song','vb-artist',
   'vb-customLine','vb-names','vb-date','vb-recordPct','vb-topMargin','vb-turns','vb-spiralFont',
   'vb-spiralGap','vb-labelPct','vb-titleFont','vb-artistFont','vb-customFont','vb-namesFont',
   'vb-dateFont','vb-labelLineH'].forEach(id=>{
    const el=$(id);if(!el)return;
    el.addEventListener('input',render);el.addEventListener('change',render);
  });
  $('vb-units').addEventListener('change',onUnitsChange);
  $('vb-btnRender').addEventListener('click',render);
  $('vb-btnDownload').addEventListener('click',downloadSVG);
  $('vb-btnDownload').addEventListener('touchend',e=>{e.preventDefault();downloadSVG();},{passive:false});

  render();
  loadFonts();
})();


